import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import DiscountBundleWarningModal from 'components/DiscountBundleWarningModal';
import { DISCOUNT_TYPES } from 'constants/discount';
import styles from './DiscountSavingsTracker.module.scss';

const DEFAULT_TRACKER_MESSAGE = 'Add more items to cart to save money';

export default function DiscountSavingsTracker({ discount, products }) {
  const [skuSet, setSkuSet] = useState(new Set());
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [trackerText, setTrackerText] = useState(DEFAULT_TRACKER_MESSAGE);

  const { lineItems } = useSelector(({ cart }) => cart);

  useEffect(() => {
    if (products?.length > 0) {
      setSkuSet(new Set(products.map((product) => product.SKU)));
    }
  }, [products]);

  useEffect(() => {
    let totalSavings = 0;
    const numberOfLineItems = lineItems.length;
    for (let i = 0; i < numberOfLineItems; i++) {
      const currentLineItem = lineItems[i];
      const { discountedPricePerQuantity, price, quantity, SKU } =
        currentLineItem;

      if (!skuSet.has(SKU)) {
        continue;
      }

      const totalSalesPrice =
        ((discountedPricePerQuantity?.discountedPrice?.centAmount ?? 0) / 100) *
        quantity;
      const totalRegularPrice = ((price?.centAmount ?? 0) / 100) * quantity;
      totalSavings = totalSavings + totalRegularPrice - totalSalesPrice;
    }
    if (totalSavings > 0) {
      setTrackerText(`You have saved $${totalSavings}`);
    } else if (trackerText !== DEFAULT_TRACKER_MESSAGE) {
      setTrackerText(DEFAULT_TRACKER_MESSAGE);
    }
  }, [lineItems, skuSet]);

  return discount.discountType === DISCOUNT_TYPES.mixandmatch ? (
    <>
      <div
        className={classNames(`rounded w-100 mb-8 p-4`, styles.savings_tracker)}
      >
        <button
          className={classNames(
            'position-absolute border-0 bg-transparent font-sofia px-0',
            styles.close_button
          )}
          id="savings_tracker_close"
          title="Close Savings Tracker"
          type="button"
          onClick={() => {
            setShowWarningModal(true);
          }}
        >
          <span>
            <FontAwesomeIcon className={styles.icon} icon={faXmark} />
          </span>
        </button>
        <div
          className={classNames(
            'font-sofia fw-700 fs-9 rounded-pill text-center text-primary border border-2 border-primary mb-5 px-5 px-md-10 py-1 py-md-3 bg-white',
            styles.tracker_text
          )}
        >
          {trackerText}
        </div>
      </div>
      <DiscountBundleWarningModal
        header="Leave Deal?"
        showModal={showWarningModal}
        onCancel={() => {
          setShowWarningModal(false);
        }}
      />
    </>
  ) : null;
}
